import React from 'react';
import { useAppContext } from 'src/components/app-context';
import type { RenderMode } from './types';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { Column } from '@prisjakt/ui/list/variants';
import { PanelHeader } from './styles';
import { PanelTitle } from '@prisjakt/ui/panel';
import type { PageInfo } from 'src/types';
import CategoryInformation from './components/category-information';
import { CategoryHeaderActions } from './category-header-actions';
import type { CompareProductsSelectionType } from 'src/hooks/compare-products-selection';
import { MediumUp } from 'src/ui/block';

export const CategoryHeader: React.FC<CategoryHeaderProps> = ({
  mode,
  onSortChange,
  pageInfo,
  showHorizontalFilter,
  immediateProducts,
  categoryName,
  productCount,
  storesCount,
  compareProductSelection,
}) => {
  const { t, market } = useAppContext();

  const productCountText = t('category', 'products.count', {
    n: productCount,
    count: productCount,
  });

  return (
    <>
      {immediateProducts ? (
        <PanelHeader>
          <Column>
            <MediumUp>
              <PanelTitle
                container="h2"
                containerProps={{ 'data-test': 'PanelHeader' }}
              >
                {t('category', 'products.title')}
              </PanelTitle>
            </MediumUp>
            <MediumUp>
              <BodySmallText>{productCountText}</BodySmallText>
            </MediumUp>
          </Column>
          <CategoryHeaderActions
            mode={mode}
            onSortChange={onSortChange}
            pageInfo={pageInfo}
            showHorizontalFilter={showHorizontalFilter}
            compareProductSelection={compareProductSelection}
          />
        </PanelHeader>
      ) : (
        <PanelTitle container="h2">
          {t('category', 'popular-products.title', {
            categoryName,
          })}
        </PanelTitle>
      )}

      {market.modules?.categoryInfo?.enabled && (
        <CategoryInformation
          statistics={{
            productsCount: productCount,
            storesCount,
          }}
        />
      )}
    </>
  );
};

interface CategoryHeaderProps {
  mode: RenderMode;
  onSortChange: (key?: string | React.Key | undefined) => void;
  pageInfo: PageInfo | null | undefined;
  showHorizontalFilter: boolean;
  productCount: number;
  storesCount: number;
  immediateProducts: boolean;
  categoryName: string;
  compareProductSelection: CompareProductsSelectionType;
}
